/**
 * IMPORTS
 */
import {Map} from 'immutable';
import {IContactTypes} from 'src/aggregates/customers/state.d';
import {ICustomerState} from 'src/aggregates/customers/state.d';


/**
 * CODE
 */
const contactTypesInitialState: IContactTypes = {
    byId: {},
    hasError: false,
    isFetching: false,
};

const initialState: ICustomerState = {
    blockWhatsappError: '',
    byContact: Map(),
    byId: Map(),
    contactAlreadyExists: false,
    contactTypes: contactTypesInitialState,
    currentCustomer: null,
    hasBlockWhatsappError: false,
    hasEditionError: false,
    hasError: false,
    hasLoadingError: false,
    hasLoadingUnassociatedContactsError: false,
    hasMorePages: true,
    hasRemovalError: false,
    hasTaggingError: false,
    hasUnblockWhatsappError: false,
    isBlockingWhatsapp: false,
    isCreating: false,
    isEditing: false,
    isLoading: false,
    isLoadingUnassociatedContacts: false,
    isRemoving: false,
    isTagging: false,
    isUnblockingWhatsapp: false,
    page: 0,
    searchTerm: '',
    tagsFilter: [],
    unblockWhatsappError: '',
};


/**
 * EXPORTS
 */
export default initialState;
